import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

import { applyGeoFilterAndNavigate } from '@/pages/klienci/common/klienciFiltersStorage'
import usePowiatData from './hooks/usePowiatData'
import usePowiatModal from './hooks/usePowiatModal'
import SearchActionsBar from '@/widgets/SearchActionsBar'
import LoadMoreSection from '@/widgets/LoadMoreSection'
import PowiatTable from './components/PowiatTable'
import PowiatModal from './components/PowiatModal'
import WojewodztwoFilterModal from '@/filter-modals/components/WojewodztwoFilterModal'

export default function Powiat() {
	const navigate = useNavigate()
	const [isWojewodztwoFilterOpen, setIsWojewodztwoFilterOpen] = useState(false)

	const {
		data,
		loading,
		loadingMore,
		error,
		totalCount,
		hasMore,
		loadData,
		handleLoadMore,
		setSorting,
		updateFilters,
		sortColumn,
		sortDirection,
		searchQuery,
		filters,
		clearError,
	} = usePowiatData()

	const {
		isModalOpen,
		editingItem,
		formName,
		setFormName,
		formWojewodztwoId,
		formWojewodztwoName,
		isSaving,
		isWojewodztwoSelectOpen,
		closeModal,
		handleSubmit,
		openWojewodztwoSelectModal,
		closeWojewodztwoSelectModal,
		applyWojewodztwoSelection,
		buttons,
	} = usePowiatModal(loadData)

	useEffect(() => {
		if (error) {
			Swal.fire({
				title: 'Error',
				text: error,
				icon: 'error',
			}).then(() => {
				clearError()
			})
		}
	}, [error, clearError])

	useEffect(() => {
		loadData()
	}, [loadData])

	const handleSort = column => {
		const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc'
		setSorting(column, newDirection)
	}

	const handleSearchChange = e => {
		updateFilters({ searchText: e.target.value })
	}

	const selectedWojewodztwoId = filters.id_wojewodztwo || null

	const handleApplyWojewodztwoFilter = wojewodztwoId => {
		updateFilters({ id_wojewodztwo: wojewodztwoId || null })
		setIsWojewodztwoFilterOpen(false)
	}

	const hasWojewodztwoFilter = !!selectedWojewodztwoId

	const handleNazwaClick = powiatId =>
		applyGeoFilterAndNavigate(navigate, {
			targetPageKey: 'gmina',
			path: '/klienci/gmina',
			filterKey: 'id_powiat',
			filterValue: powiatId,
		})

	return (
		<>
			<SearchActionsBar
				value={searchQuery}
				onChange={handleSearchChange}
				placeholder="Szukaj powiatow po nazwie..."
				buttons={buttons}
			/>

			<PowiatTable
				data={data}
				loading={loading}
				sortColumn={sortColumn}
				sortDirection={sortDirection}
				onSort={handleSort}
				hasWojewodztwoFilter={hasWojewodztwoFilter}
				onOpenWojewodztwoFilter={() => setIsWojewodztwoFilterOpen(true)}
				onWojewodztwoFilter={handleApplyWojewodztwoFilter}
				onNazwaClick={handleNazwaClick}
			/>

			<LoadMoreSection
				hasMore={hasMore}
				loadingMore={loadingMore}
				onLoadMore={handleLoadMore}
				dataLength={data.length}
				totalCount={totalCount}
			/>
			<PowiatModal
				isOpen={isModalOpen}
				editingItem={editingItem}
				formName={formName}
				setFormName={setFormName}
				formWojewodztwoId={formWojewodztwoId}
				formWojewodztwoName={formWojewodztwoName}
				onOpenWojewodztwoSelect={openWojewodztwoSelectModal}
				isSaving={isSaving}
				onClose={closeModal}
				onSubmit={handleSubmit}
			/>
			<WojewodztwoFilterModal
				isOpen={isWojewodztwoFilterOpen}
				onClose={() => setIsWojewodztwoFilterOpen(false)}
				selectedWojewodztwoId={selectedWojewodztwoId}
				onApply={handleApplyWojewodztwoFilter}
			/>
			<WojewodztwoFilterModal
				isOpen={isWojewodztwoSelectOpen}
				onClose={closeWojewodztwoSelectModal}
				selectedWojewodztwoId={formWojewodztwoId}
				onApply={applyWojewodztwoSelection}
				title="Wybierz wojewodztwo"
				description="Wyszukaj i wybierz wojewodztwo dla powiatu."
				applyLabel="Wybierz"
				clearLabel="Wyczysc wybor"
			/>
		</>
	)
}
